import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, FormTextArea } from 'components/form-fields';
import { TopicSnapshot } from 'pages/employee-reviews/completed/snapshots';

// A topic step of the edit wizard for a topic whose record the edit cannot change: the record as
// it was frozen at completion, read-only, and the topic's comment to correct.
export function SnapshotCommentEditStep(
    {
        state = null,
        topicEntry = null,
        loading = false,
        onChange
    }
) {

    function onCommentChange(event) {
        onChange({ comment: event.target.value });
    }

    return (
        <div>
            <div className="inline-items inline-items-space spacer-bottom-small">
                <h2>{topicEntry?.topicName}</h2>
            </div>
            <FormHelperText loading={loading}>As recorded when the review was completed. Only the comment can be changed.</FormHelperText>
            <TopicSnapshot data={topicEntry?.data} loading={loading} displayInRows />
            <div className="spacer-top">
                <FormTextArea
                    id="topic-comment"
                    headingText="Overall comments"
                    placeholder="Add any overall comments for this topic..."
                    value={state?.comment ?? ""}
                    loading={loading}
                    fill
                    onChange={onCommentChange}
                />
            </div>
        </div>
    );
}

SnapshotCommentEditStep.propTypes = {
    state: PropTypes.object,
    topicEntry: PropTypes.object,
    loading: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};
